import { TextInput } from "react-native"; // eslint-disable-line import/no-unresolved
var TextInputState = TextInput.State;
export default function dismissKeyboard() {
  TextInputState.blurTextInput(TextInputState.currentlyFocusedInput());
}